import React from "react";

const Skeleton = () => (
  <div className="space-y-5 animate-pulse">
    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="h-8 w-80 rounded bg-slate-200"></div>
      <div className="mt-3 h-4 w-48 rounded bg-slate-200"></div>

      <div className="mt-6 flex gap-4">
        <div className="h-10 w-32 rounded-lg bg-slate-200"></div>
        <div className="h-10 w-48 rounded-lg bg-slate-200"></div>
        <div className="h-10 w-24 rounded-lg bg-slate-200"></div>
      </div>
    </div>

    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      {[...Array(8)].map((_, index) => (
        <div key={index} className="mb-4 h-8 rounded bg-slate-100" />
      ))}
    </div>
  </div>
);

export default Skeleton;
